import app from "./config/configApp";
import router from "./routes/protectedRoute";
import store from "@/vuex/store";
import "./static/scss/index.scss";
// Vue 3rd party plugins
import "@/core/plugins/ant-design";
import "@/core/plugins/fonts";
import "@/core/plugins/unicons";
import "@/core/components/custom";
import { BasicFormWrapper } from "./view/styled";
import { SelectWrapperStyle } from "./view/uiElements/ui-elements-styled";
import { Search } from "../src/components/utilities/auth-info/Search.vue";
import { Message } from "ant-design-vue";
import FormLayout from "./components/form-layouts/FormLayout";
import PageHeader from "./components/toolbar/PageHeader";
import Multiselect from 'vue-multiselect'
import { DatePickerWrapper } from "./view/styled";

app.config.productionTip = false;

app.component("BasicFormWrapper", BasicFormWrapper);
app.component("SelectWrapperStyle", SelectWrapperStyle);
app.component("Search", Search);
app.component("Message", Message);
app.component("PageHeader", PageHeader);
app.component("FormLayout", FormLayout);
app.component('multiselect', Multiselect)
app.component('DatePickerWrapper',DatePickerWrapper)
app.use(store);
app.use(router);
app.mount("#app");
